<template>
  <div v-if="recommendPlayList && recommendPlayList.length" class="list-like-game">
    <div class="list-like-game-top">
      <p class="like-game-top-title">{{ title || "更多精彩" }}</p>
      <p class="like-game-top-go" @click="goToGameList()">全部游戏</p>
    </div>
    <recommendPlayItem :recommend-play-list="recommendPlayList" pf-structure="hotgame"></recommendPlayItem>
  </div>
</template>
<script>
// 备注此组件原为 v_zqllu 缩写，后面由于首页也需要，因此将内容抽出来
import { mapActions } from "vuex"
import recommendPlayItem from "../../common/List/recommendPlayItem.vue"

export default {
  components: {
    recommendPlayItem
  },
  props: ["recommendPlayList", "iformat", "pfStructure", "redirectRoute", "title"],

  methods: {
    ...mapActions(["reportUserAction"]),

    /**
     * 跳转到游戏列表
     */
    goToGameList() {
      this.$router.push({
        name: this.redirectRoute,
        query: {
          ...this.$route.query,
          tab: "game"
        }
      })

      this.reportUserAction({
        iformat: this.iformat,
        pfStructure: this.$route.query.pfStructure
      })
    }
  }
}
</script>
